/**
 * 公共基础设定使用的mix 混合
 */

import {companyTrans, mediaTrans, searchApp} from '@/http/settingApi'
import {allDept, searchUserList} from "@/http/api";
import ArrayUtil from '@/utils/ArrayUtil'
import {
    taskSelections,
    goodsCategoryList,
    goodsCategoryAll,
    goodsLevel,
    shopItemClassifyList,
    cupBoardshopItemStock,
    shopItemAll,
    dailyShopItemType,
    cupBoardShopItemClassifyList, kittyChannelList
} from "../../http/iosApi";
import {
    allDogChannel,
    dogCategoryAll,
    dogCategoryList
} from "../../http/dogApi";
import {
    allChannel,
    bookCustomType,
    bookGoodsCategoryAll,
    bookGoodsCategoryList,
    bookGoodsLevel,
    bookTaskSelections,
    shopItemClassifyListBook
} from "../../http/iosBookApi";
import {
    allChannel as aiAllChannel,
    bookCustomType as aiBookCustomType,
    bookGoodsCategoryAll as aiBookGoodsCategoryAll,
    bookGoodsCategoryList as aiBookGoodsCategoryList,
    bookGoodsLevel as aiBookGoodsLevel,
    bookTaskSelections as aiBookTaskSelections,
    shopItemClassifyListBook as aiShopItemClassifyListBook
} from "../../http/aiBookAdminApi";
import { shopItemStock} from "@/http/iosUserApi";
import {shopItemStockBook} from "@/http/iosBookUserApi";
import {shopItemStockBook as aiShopItemStockBook} from "@/http/aiBookUserApi";
import {
    allGatherChannel,
    cgCustomType,
    cgGoodsCategoryAll,
    cgGoodsCategoryList,
    cgGoodsLevel,
    cgShopItemClassifyList,
    cgTaskSelections
} from "@/http/cgApi";
import {cgShopItemStock} from "@/http/cgUserApi";
import {womenTaskSelections} from "@/http/womensApi";

export default {
    data() {
        return {
            appObj: {},
            appList: [],
            companyObj: {}, //简称翻译
            companyAllObj: {}, //全称翻译
            mediaType: 0, //媒体类型， 0：全部，1：表示流量变现，2：表示投放
            mediaObj: {},
            depts:[],
            deptObj:{},
            userObj:{},
            iosAppObj:{},
            iosShopClassifyObj:{},
            dailyShopItemTypeObj:{},
            aiBookDailyShopItemTypeObj:{},
            bookDailyShopItemTypeObj:{},
            iosShopStockObj:{},
            iosShopStockObjCupBoard:[],
            iosAppList: [],
            iosTaskSelections: {},
            categoryList: [],
            dogCategoryList: [],
            categoryAll: [],
            dogCategoryAll:[],
            itemList: [],
            goodLevelList: [],
            iosBookTaskSelections: {},
            iosBookCategoryList: [],
            iosBookCategoryAll: [],
            iosBookGoodLevelList: [],
            iosBookCustomTypeObj: {},
            iosBookCustomTypeList: [],
            iosBookChannelList: [],
            iosDogChannelList:[],
            iosBookChannelObject: {},
            iosDogChannelObject:{},
            aiIosBookTaskSelections: {},
            aiIosBookCategoryList: [],
            aiIosBookCategoryAll: [],
            aiIosBookGoodLevelList: [],
            aiIosBookCustomTypeObj: {},
            aiIosBookCustomTypeList: [],
            aiIosBookChannelList: [],
            aiIosBookChannelObject: {},
            iosKittyChannelList: [],
            iosKittyChannelObject: {},
            iosGatherChannelList:{},
            iosGatherChannelObject:{},

            cgTaskSelections: {},
            cgCategoryList: [],
            cgCategoryAll: [],
            cgGoodLevelList: [],
            cgCustomTypeObj: {},
            cgCustomTypeList: [],
            //控制是否获取对应的app应用、公司等翻译信息的开关
            needGetApp: false,
            needGetCompany: false,
            needGetMedia: false,
            needDept: false,
            needUser: false,
            needIosApp: false,
            needIosTaskSelections: false,
            needCategoryInfo: false,
            needDogCategoryInfo: false,
            needCategoryAll: false,
            needGoodLevel: false,
            needIosBookTaskSelections: false,
            needIosBookCategoryInfo: false,
            needIosBookCategoryAll: false,
            needIosBookGoodLevel: false,
            needBookCustomType: false,
            needAiIosBookTaskSelections: false,
            needAiIosBookCategoryInfo: false,
            needAiIosBookCategoryAll: false,
            needAiIosBookGoodLevel: false,
            needAiBookCustomType: false,

            needCgTaskSelections: false,
            needCgCategoryInfo: false,
            needCgCategoryAll: false,
            needCgGoodLevel: false,
            needCgCustomType: false,

            needBookChannel: false,
            needGatherChannel:false,
            needDogChannel:false,
            needAiBookChannel: false,
            needKittyChannel: false,
            needDailyShoppingItemType: false
        }
    },
    methods: {
        /**
         * 获取应用信息，存储翻译的信息
         */
        getAppTrans() {
            let req = {
                dept: -1,
                state: -1,
                order: 'descending',
                prop: 'app_id',
                size: 9999,
                page: 1
            }
            searchApp(req).then(resp => {
                this.appList = resp.data.info.content
                const uniqueMap = new Map();
                resp.data.info.content.forEach(item => {
                    // 只保留第一个出现的 packageName 对应的项
                    if (!uniqueMap.has(item.packageName)) {
                        uniqueMap.set(item.packageName, item);
                    }
                    // 重复项直接跳过，不做处理
                });
                this.appList = Array.from(uniqueMap.values());
                this.appObj = ArrayUtil.transferList2Obj(this.appList, 'appId', 'appName')
            })
        },
        getAppTransPackage() {
            let req = {
                dept: -1,
                state: -1,
                order: 'descending',
                prop: 'app_id',
                size: 9999,
                page: 1
            }
            searchApp(req).then(resp => {
                this.appList = resp.data.info.content
                const uniqueMap = new Map();
                resp.data.info.content.forEach(item => {
                    // 只保留第一个出现的 packageName 对应的项
                    if (!uniqueMap.has(item.packageName)) {
                        uniqueMap.set(item.packageName, item);
                    }
                    // 重复项直接跳过，不做处理
                });
                this.appList = Array.from(uniqueMap.values());
                this.appObj = ArrayUtil.transferList2Obj(this.appList, 'packageName', 'appName')
            })
        },
        /**
         * 获取公司信息，存储翻译的信息
         */
        getCompanyTrans() {
            companyTrans().then(resp => {
                this.companyObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'abbreviation')
                this.companyAllObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'companyName')
                console.info(JSON.stringify(this.companyObj))
            })
        },
        /**
         * 获取媒体信息，存储翻译的信息
         */
        getMediaTrans() {
            mediaTrans(this.mediaType).then(resp => {
                this.mediaObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'name')
                console.info(JSON.stringify(this.mediaObj))
            });
            mediaTrans(0).then(resp => {
                this.mediaList = resp.data.info;

            });

        },
        /**
         * 部门信息获取
         */
        deptList() {
            allDept().then(resp => {
                this.depts = resp.data.info;
                this.deptObj = ArrayUtil.transferList2Obj(resp.data.info, 'deptId', 'name')
            })
        },
        /**
         * 用户信息登录
         */
        getUserTrans() {
            searchUserList({account: '', state: 0}).then(resp => {
                this.userObj = ArrayUtil.transferList2Obj(resp.data.info, 'uid', 'account')
            })
        },
        getIosAppTrans() {
            let req = {
                dept: 2,
                state: -1,
                order: 'descending',
                prop: 'app_id',
                size: 9999,
                page: 1
            }
            searchApp(req).then(resp => {
                this.iosAppList = resp.data.info.content
                console.log(this.iosAppList)
            })
            let req1 = {
                dept: 3,
                state: -1,
                order: 'descending',
                prop: 'app_id',
                size: 9999,
                page: 1
            }
            searchApp(req1).then(resp => {
                this.iosAppList.push(...resp.data.info.content)
                console.log(this.iosAppList)
            })
            let req3 = {
                dept: 5,
                state: -1,
                order: 'descending',
                prop: 'app_id',
                size: 9999,
                page: 1
            }
            searchApp(req3).then(resp => {
                this.iosAppList.push(...resp.data.info.content)
                console.log(this.iosAppList)
            })
            let req2 = {
                dept: 4,
                state: -1,
                order: 'descending',
                prop: 'app_id',
                size: 9999,
                page: 1
            }
            searchApp(req2).then(resp => {
                this.iosAppList.push(...resp.data.info.content)
                console.log(this.iosAppList)
                this.iosAppObj = ArrayUtil.transferList2Obj(this.iosAppList, 'appId', 'appName')
            })

        },
        getIosTaskSelections() {
            taskSelections().then(resp => {
                this.iosTaskSelections = resp.data.info;
            })
        },
        getCategoryInfo() {
            goodsCategoryList().then(resp => {
                this.categoryList = resp.data.info;
            })
        },
        getDogCategoryInfo() {
            dogCategoryList().then(resp => {
                this.dogCategoryList = resp.data.info;
            })
        },
        getCategoryAll() {
            goodsCategoryAll().then(resp => {
                this.categoryAll = resp.data.info;
            })
        },
        getDogCategoryAll() {
            dogCategoryAll().then(resp => {
                this.dogCategoryAll = resp.data.info;
            })
        },
        getGoodLevel() {
            goodsLevel().then(resp => {
                this.goodLevelList = resp.data.info;
            })
        },
        getDailyShoppingItemTypeTrans() {
            dailyShopItemType().then(resp => {
                this.dailyShopItemTypeObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'name')
            })
        },
        getShopClassifyNameTrans() {
            shopItemClassifyList().then(resp => {
                this.iosShopClassifyObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'name')
            })
        },
        getCupBoardShopClassifyNameTrans(){
            cupBoardShopItemClassifyList().then(resp =>{
                this.cupBoardShopStockObj = ArrayUtil.transferList2Obj(resp.data.info,'id','name')
            })
        },
        getShopItemStockTrans(){
            shopItemStock().then(resp =>{
                this.iosShopStockObj = ArrayUtil.transferList2Obj(resp.data.info,'id','currentStock')
            })
        },
        getCupBoardShopItemStockTrans(){
            cupBoardshopItemStock().then(resp =>{
                this.iosShopStockObjCupBoard = ArrayUtil.transferList2Obj(resp.data.info,'id','currentStock')
            })
        },
        getShopClassifyNameTransBook(){
            shopItemClassifyListBook().then(resp => {
                this.iosShopClassifyObjBook = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'name')
            })
        },
        getShopItemStockTransBook() {
            shopItemStockBook().then(resp => {
                this.iosShopStockObjBook = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'currentStock')
            })
        },
        getAiShopClassifyNameTransBook(){
            aiShopItemClassifyListBook().then(resp => {
                this.aiIosShopClassifyObjBook = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'name')
            })
        },
        getAiShopItemStockTransBook() {
            aiShopItemStockBook().then(resp => {
                this.aiIosShopStockObjBook = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'currentStock')
            })
        },
        getCgShopClassifyNameTrans() {
            cgShopItemClassifyList().then(resp => {
                this.cgShopClassifyObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'name')
            })
        },
        getCgShopItemStockTrans() {
            cgShopItemStock().then(resp => {
                this.cgShopStockObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'currentStock')
            })
        },
        getShopItemList() {
            shopItemAll(1).then(resp => {
                this.itemList = resp.data.info
            })
        },
        getIosBookTaskSelections() {
            bookTaskSelections().then(resp => {
                this.iosBookTaskSelections = resp.data.info;
            })
        },
        getWomenTaskSelections() {
            womenTaskSelections().then(resp => {
                this.womenTaskSelections = resp.data.info;
            })
        },
        getIosBookCategoryInfo() {
            bookGoodsCategoryList().then(resp => {
                this.iosBookCategoryList = resp.data.info;
            })
        },
        getIosBookCategoryAll() {
            bookGoodsCategoryAll().then(resp => {
                this.iosBookCategoryAll = resp.data.info;
            })
        },
        getIosBookGoodLevel() {
            bookGoodsLevel().then(resp => {
                this.iosBookGoodLevelList = resp.data.info;
            })
        },
        getIosBookCustomType() {
            bookCustomType().then(resp => {
                this.iosBookCustomTypeList = resp.data.info;
                this.iosBookCustomTypeObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'name')
                console.info(JSON.stringify(this.iosBookCustomTypeObj))
            })
        },

        getAiIosBookTaskSelections() {
            aiBookTaskSelections().then(resp => {
                this.aiIosBookTaskSelections = resp.data.info;
            })
        },
        getAiIosBookCategoryInfo() {
            aiBookGoodsCategoryList().then(resp => {
                this.aiIosBookCategoryList = resp.data.info;
            })
        },
        getAiIosBookCategoryAll() {
            aiBookGoodsCategoryAll().then(resp => {
                this.aiIosBookCategoryAll = resp.data.info;
            })
        },
        getAiIosBookGoodLevel() {
            aiBookGoodsLevel().then(resp => {
                this.aiIosBookGoodLevelList = resp.data.info;
            })
        },
        getAiIosBookCustomType() {
            aiBookCustomType().then(resp => {
                this.aiIosBookCustomTypeList = resp.data.info;
                this.aiIosBookCustomTypeObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'name')
                console.info(JSON.stringify(this.aiIosBookCustomTypeObj))
            })
        },

        getCgTaskSelections() {
            cgTaskSelections().then(resp => {
                this.cgTaskSelections = resp.data.info;
            })
        },
        getCgCategoryInfo() {
            cgGoodsCategoryList().then(resp => {
                this.cgCategoryList = resp.data.info;
            })
        },
        getCgCategoryAll() {
            cgGoodsCategoryAll().then(resp => {
                this.cgCategoryAll = resp.data.info;
            })
        },
        getCgGoodLevel() {
            cgGoodsLevel().then(resp => {
                this.cgGoodLevelList = resp.data.info;
            })
        },
        getCgCustomType() {
            cgCustomType().then(resp => {
                this.cgCustomTypeList = resp.data.info;
                this.cgCustomTypeObj = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'name')
                console.info(JSON.stringify(this.cgCustomTypeObj))
            })
        },
        getIosBookChannel() {
            allChannel().then(resp => {
                this.iosBookChannelList = resp.data.info;
                this.iosBookChannelObject = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'channel')

            })
        },
        getIosDogChannel() {
            allDogChannel().then(resp => {
                this.iosDogChannelList = resp.data.info;
                this.iosDogChannelObject = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'channel')

            })
        },
        getIosGatherChannel() {
            allGatherChannel().then(resp => {
                this.iosGatherChannelList = resp.data.info;
                this.iosGatherChannelObject = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'channel')

            })
        },
        getAiIosBookChannel() {
            aiAllChannel().then(resp => {
                this.aiIosBookChannelList = resp.data.info;
                this.aiIosBookChannelObject = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'channel')

            })
        },
        getIosKittyChannel() {
            kittyChannelList().then(resp => {
                this.iosKittyChannelList = resp.data.info;
                this.iosKittyChannelObject = ArrayUtil.transferList2Obj(resp.data.info, 'id', 'channel')

            })
        },
    },
    created() {
        this.needGetApp && this.getAppTrans();
        this.needGetApp && this.getAppTransPackage();
        this.needGetCompany && this.getCompanyTrans();
        this.needGetMedia && this.getMediaTrans();
        this.needDept && this.deptList();
        this.needUser && this.getUserTrans();
        this.needIosApp && this.getIosAppTrans();
        this.needIosTaskSelections && this.getIosTaskSelections();
        this.needCategoryInfo && this.getCategoryInfo();
        this.needDogCategoryInfo && this.getDogCategoryInfo();

        this.needCategoryAll && this.getCategoryAll();
        this.needDogCategoryAll && this.getDogCategoryAll();


        this.needCategoryAll && this.getShopClassifyNameTrans();
        this.needDailyShoppingItemType && this.getDailyShoppingItemTypeTrans();
        this.needCategoryAll && this.getShopItemStockTrans();
        this.needCategoryAll && this.getShopItemList();
        this.needGoodLevel && this.getGoodLevel()
        this.needIosBookTaskSelections && this.getIosBookTaskSelections();
        this.needWomenTaskSelections && this.getWomenTaskSelections();
        this.needIosBookCategoryInfo && this.getIosBookCategoryInfo();
        this.needIosBookCategoryAll && this.getIosBookCategoryAll();
        this.needIosBookCategoryAll && this.getShopClassifyNameTransBook();
        this.needIosBookCategoryAll && this.getShopItemStockTransBook();
        this.needIosBookGoodLevel && this.getIosBookGoodLevel();
        this.needBookCustomType && this.getIosBookCustomType();
        this.needBookChannel && this.getIosBookChannel();

        this.needAiIosBookTaskSelections && this.getAiIosBookTaskSelections();
        this.needAiIosBookCategoryInfo && this.getAiIosBookCategoryInfo();
        this.needAiIosBookCategoryAll && this.getAiIosBookCategoryAll();
        this.needAiIosBookCategoryAll && this.getAiShopClassifyNameTransBook();
        this.needAiIosBookCategoryAll && this.getAiShopItemStockTransBook();
        this.needAiIosBookGoodLevel && this.getAiIosBookGoodLevel();
        this.needAiBookCustomType && this.getAiIosBookCustomType();
        this.needAiBookChannel && this.getAiIosBookChannel();

        this.needKittyChannel && this.getIosKittyChannel();

        this.needCategoryAll && this.getCupBoardShopClassifyNameTrans();
        this.needCategoryAll && this.getCupBoardShopItemStockTrans();

        this.needIosBookGoodLevel && this.getIosBookGoodLevel()
        this.needBookCustomType && this.getIosBookCustomType()
        this.needAiIosBookGoodLevel && this.getAiIosBookGoodLevel()
        this.needAiBookCustomType && this.getAiIosBookCustomType()

        this.needCgTaskSelections && this.getCgTaskSelections();
        this.needCgCategoryInfo && this.getCgCategoryInfo();
        this.needCgCategoryAll && this.getCgCategoryAll();
        this.needCgCategoryAll && this.getCgShopClassifyNameTrans();
        this.needCgCategoryAll && this.getCgShopItemStockTrans();
        this.needCgGoodLevel && this.getCgGoodLevel()
        this.needCgCustomType && this.getCgCustomType()

        this.needBookChannel && this.getIosBookChannel()
        this.needDogChannel &&this.getIosDogChannel()
        this.needAiBookChannel && this.getAiIosBookChannel()
        this.needGatherChannel && this.getIosGatherChannel()
    }
}
